---
title: "Latah AuxComm, Latah ARES, and DSARC Weekly Packet Net SOP"
---

**Standard Operating Procedure for Latah AuxComm, Latah ARES, and DSARC Weekly Packet Net**

---

**1. Purpose**
The purpose of this Standard Operating Procedure (SOP) is to establish guidelines for the weekly packet net operations, fostering proficiency in packet radio communications for AuxComm, ARES, and DSARC members.

**2. Weekly Packet Net Objectives**

- Maintain regular communication practice.
- Familiarize members with using packet radio tools and nodes.
- Provide alternative connectivity through telnet for those unable to use RF.

**3. General Information**

- **Primary Node:** KI7LAC on 145.050 MHz.
  - **Node:** KI7LAC-7
  - **BBS:** KI7LAC-1
  - **RMS (Winlink):** KI7LAC-10
  - **Chatroom:** KI7LAC-11
- **Fallback Node:** K7LL-7 for indirect access to KI7LAC.
- **Net Control Time:** Tuesdays at 1830 or close of voice net.
- **Alternate Access:** Telnet for participants unable to connect via RF.

**4. Net Structure**

- **Call to Order:**

  1. Participants begin by connecting to KI7LAC-7. If unable to reach it directly, K7LL-7 may be used as a digipeater to connect to KI7LAC-7 but does not serve as a fallback node. KI7LAC-7 is the primary and operations node for the net.
  2. NCS will initiate the net by instructing participants to connect to KI7LAC-7 and check into the KI7LAC-11 chatroom. There is no voice component, and the call to order is conducted entirely via packet communications.

- **Check-in:**

  1. Participants check into the KI7LAC-11 chatroom. This check-in constitutes participation in the net.
  2. Any assignments or tasks will be communicated via the chatroom.

- **Net Assignments:**

  1. Participants will initially receive their assignments through the KI7LAC-11 chatroom. As the net progresses, assignments will transition to being retrieved from the KI7LAC-1 BBS.
  2. Tasks may include sending a Winlink message or reporting specific information like weather conditions.

- **Completion of Tasks:**

  1. Participants complete their assignments and report back to the KI7LAC-11 chatroom as confirmation.

- **Closing the Net:**

  1. The net concludes when all participants have completed their tasks and confirmed completion by reporting back in the KI7LAC-11 chatroom.
  2. NCS provides closing comments and adjourns the net.

**5. Instructions for Telnet Participants**

- Telnet participants will connect to KI7LAC-7 and complete tasks as outlined in the net instructions.
- Access instructions for Telnet: [Provide details].

**6. Net Control Responsibilities**

- Start the net and guide participants through the agenda.
- Monitor participants’ progress and provide assistance as needed.
- Track attendance and ensure task completion.
- Send practice messages and maintain logs of tasks completed.

**7. Participant Guidelines**

- Ensure all equipment is functioning before the net.
- Connect to KI7LAC-7 (or use K7LL-7 as a digipeater if necessary).
- Check into the KI7LAC-11 chatroom promptly.
- Complete assignments and report back in a timely manner.
- Ask questions or request help as needed during the net.

**8. Evaluation and Feedback**

- After each net, participants are encouraged to provide feedback to improve future sessions.
- NCS will provide constructive feedback and guidance to participants.

**9. Resources and Contact Information**

- Packet Radio Guide: [Provide link or reference].
- Technical Support Contact: [Provide details].
- Net Control Contact: [Provide details].